import string from "actions/helper/string";

const sumFormat = new Intl.NumberFormat('ru-RU');
const { spaceChar, priceChar } = string;

const obj = {
    toSum(num) {
        return sumFormat.format(Math.round(num || 0)) + spaceChar + priceChar;
    },

    random(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    },

    roundBy(number, del = 1) {
        return (Math.round(number / del) * del);
    },

    roundByFloor(number, del = 1) {
        return (Math.floor(number / del) * del);
    },

    percentMinus(sum, per) {
        return sum - sum * (per / 100);
    },

    generateUniqueID() {
        return Date.now() % 100000000;
    },

    getCorrectProcent({ value }, discount) {
        const roundValue = parseFloat((Math.round(this.percentMinus(value, discount) * 10) / 10).toFixed(0));
        const newDiscount = value ? ((value - roundValue) / value) * 100 : 0;
        return newDiscount;
    },

    calculatePercentForInvoice(rows, discount, totalInvoice) {
        let sumInvoiceDiscount = 0;
        let countRowAcceptDicount = 0;
        let pos = 0;
        rows = rows.map(teeth => {
            teeth.items = teeth.items.map(item => {
                if (!item.noDiscount) {
                    countRowAcceptDicount++;
                    item.discount = this.getCorrectProcent(item, discount);
                } else
                    item.discount = 0;

                let amountAfterDeduction = this.percentMinus(item.value, item.discount);
                sumInvoiceDiscount += amountAfterDeduction * item.count;
                pos++;
                item.sortIndex = pos;
                return item;
            });

            return teeth;

        });

        if (totalInvoice !== sumInvoiceDiscount) {
            const lessSum = totalInvoice - sumInvoiceDiscount;
            const addSum = Math.floor(lessSum / countRowAcceptDicount);
            const addLastSum = lessSum - (addSum * countRowAcceptDicount);

            let i = 0;
            for (let teeth of rows) {
                for (let item of teeth.items) {
                    if (!item.noDiscount) {
                        i++;
                        let sum = this.percentMinus(item.value, item.discount) * item.count;
                        let s = (i === countRowAcceptDicount) ? addSum + addLastSum : addSum;
                        let newSum = (sum + s) / item.count;
                        let percentage = 100 - ((newSum / item.value) * 100);
                        item.discount = percentage;
                    }
                }
            }
        }

        sumInvoiceDiscount = 0;

        rows = rows.map(teeth => {
            teeth.items.map(item => {
                const amountAfterDeduction = this.percentMinus(item.value, item.discount);
                sumInvoiceDiscount += amountAfterDeduction * item.count;
                return item;
            });
            return teeth;
        });

        sumInvoiceDiscount = parseFloat(sumInvoiceDiscount).toFixed(2);

        let error = null;
        if (totalInvoice !== 0 && ((sumInvoiceDiscount % 1 !== 0) || totalInvoice !== (sumInvoiceDiscount / 1)))
            error = "Ошибка в скидке, назначьте другую скидку или обратитесь к Администратору";

        const res = {
            rows,
            error
        };

        return res;
    }
};

export default obj;
